import request, { POST_REQUEST } from '@helpers/request';
import {
  API_ERECRUITMENT_PATH,
  API_ERECRUITMENT_PATH_V2,
  API_ERECRUITMENT_PATH_V2_PUB,
  API_ERECRUITMENT_PUB_PATH,
  API_FTA_ERECRUITMENT_PATH,
  S3_LINK,
} from '../env';

const { VITE_API_URL } = import.meta.env;

const API_POST_FILE = S3_LINK;

const structurePaths = {
  common: {
    getDocBufferedData: `${API_ERECRUITMENT_PATH_V2_PUB}/get-doc-buffered`,
  },
  detail: {
    getDetail: `${API_ERECRUITMENT_PATH_V2}/get-detail`,
    getProcessHistories: `${API_ERECRUITMENT_PATH_V2}/get-eapp-process-history`,
  },
  nousDetail: {
    getDetail: `${API_ERECRUITMENT_PATH_V2}/nous/get-detail`,
  },
  flairDetail: {
    getDetail: `${API_ERECRUITMENT_PATH_V2}/flair/get-detail`,
  },
  delasolDetail: {
    getDetail: `${API_ERECRUITMENT_PATH_V2}/delasol/get-detail`,
  },
};

export const searchPreCandidate = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/search-pre-candidate`, {
    method: 'POST',
    data,
  });

export const createCandidateListService = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/candidate-list/create`, {
    method: 'POST',
    data,
  });

export const searchCandidateListService = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/candidate-list/search`, {
    method: 'POST',
    data,
  });

export const getCandidateHistoryService = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/candidate-list/history`, {
    method: 'POST',
    data,
  });

export const getCandidateApplicationsService = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/candidate-list/applications`, {
    method: 'POST',
    data,
  });

export const updateCandidateListService = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/candidate-list/update`, {
    method: 'POST',
    data,
  });

export const presentCandidateListService = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/candidate-list/present`, {
    method: 'POST',
    data,
  });

export const deleteCandidateListService = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/candidate-list/delete`, {
    method: 'POST',
    data,
  });

export const searchPreCandidateCourse = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/search-course`, {
    method: 'POST',
    data,
  });

export const searchInfoCandidateCourse = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/search-info-candidate`, {
    method: 'POST',
    data,
  });

export const searchClassCandidateCourse = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/search-class-candidate`, {
    method: 'POST',
    data,
  });

export const getStatusService = () => {
  return request(`${API_ERECRUITMENT_PATH_V2}/status`, {
    method: 'GET',
  });
};

export const getAllAdService = () => {
  return request(`${API_ERECRUITMENT_PATH}/get-all-ad`, {
    method: 'GET',
  });
};

export const getAllAmService = ({ channel }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/get-am-under-ad`, {
    method: 'GET',
  });
};

export const getListTrainingClassService = () => {
  return request(`${API_ERECRUITMENT_PATH}/get-list-training-class`, {
    method: 'GET',
  });
};

export const getListOfValueService = (
  lovTypes = [
    'RACE',
    'GEN',
    'EDU',
    'OCCP',
    'MARL',
    'BANK',
    'REL_TYP',
    'ADDR_TYP',
    'AGT_TITLE',
    'FTA_LV',
    'AGT_CAT',
    'COMP',
    'AD_EVALUATION',
    'DOC_TYP',
    'TPB_BNK_TITLE',
    'ACB_BNK_TITLE',
    'ACB_BNK_GRP_TITLE',
    'TPB_BNK_GRP_TITLE',
  ],
) => {
  return request(
    `${API_ERECRUITMENT_PATH}/get-list-of-value?lovTypes=${lovTypes.join(',')}`,
    {
      method: 'GET',
    },
  );
};

export const getProvincesService = () => {
  return request(`${API_ERECRUITMENT_PATH}/get-provinces?countryCode=VN`, {
    method: 'GET',
  });
};

export const getDistrictsService = (provinceCode) => {
  return request(
    `${API_ERECRUITMENT_PATH}/get-districts?provinceCode=${provinceCode}`,
    {
      method: 'GET',
    },
  );
};

export const getWardsService = (districtCode) => {
  return request(
    `${API_ERECRUITMENT_PATH}/get-wards?districtCode=${districtCode}`,
    {
      method: 'GET',
    },
  );
};

export const getListOfficeService = () => {
  return request(`${API_ERECRUITMENT_PATH}/get-list-office`, {
    method: 'GET',
  });
};

export const getTitleForNousService = () => {
  return request(`${API_ERECRUITMENT_PUB_PATH}/get-title-for-nous`, {
    method: 'GET',
  });
};

// export const registerByRecruiterService = (data) => {
//   return request(`${API_ERECRUITMENT_PATH}/register-by-recruiter`, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//     data,
//   });
// };

export const registerByRecruiterService = (data) => {
  if (data?.isRecruitReSubmit) {
    return request(`${API_ERECRUITMENT_PATH_V2}/resubmit-by-recruiter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  }
  return request(`${API_ERECRUITMENT_PATH_V2}/register-by-recruiter`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const updateEmailByRecruiterService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/update-email-by-recruiter`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const saveByRecruiterService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/save-temporary-by-recruiter`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const submitChangeCourseService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/submit-change-course`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const validateCandidateInfoChangeCourseService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/validate-candidate-info-change-course`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const cloneAppNoService = (data) => {
  return request(`${API_ERECRUITMENT_PATH}/clone-eApp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const cloneAppNoServiceFTA = (data) => {
  return request(`${API_FTA_ERECRUITMENT_PATH}/clone-eApp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const checkDuplicatePhoneService = (data) => {
  return request(`${API_ERECRUITMENT_PATH}/check-duplicate-phone-number`, {
    method: 'POST',
    data,
  });
};

export const createPostPresignedService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/create-post-presigned`, {
    method: 'POST',
    data,
  });
};

export const uploadS3Directly = (id, fileName, file) => {
  const formData = new FormData();
  if (file) {
    formData.append('file', file, fileName || file.name);
  }
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/upload-file/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
};

export const postFileService = (data) => {
  return request(`${API_POST_FILE}`, {
    method: 'POST',
    skipAuth: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
};

export const getTrackingService = ({ id = '', step = 'RECRUIT_PRCES' }) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/tracking/${id}?step=${step}`,
    {
      method: 'GET',
    },
  );
};

export const updateByPreCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/update-by-pre-candidate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const checkStepCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/check-step-candidate`, {
    method: 'POST',
    data,
  });
};

export const kaptchaImageService = (time) => {
  return request(`${VITE_API_URL}/captcha/kaptcha-image.do?${time}`, {
    method: 'GET',
    responseType: 'blob',
  });
};

export const generateOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/generate-otp`, {
    method: 'POST',
    data,
  });
};

export const reloadOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/reload-otp`, {
    method: 'POST',
    data,
  });
};

export const verifyOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/verify-otp`, {
    method: 'POST',
    data,
  });
};

export const checkApplicationStatusService = (data) => {
  return request(`${VITE_API_URL}/pub/ekyc/e-recruitment/status/${data}`, {
    method: 'GET',
  });
};

export const candidateCancelEAppService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/candidate-cancel-eapp`, {
    method: 'POST',
    data,
  });
};

export const getEreDetailService = (data) => {
  if (data?.isCandidate) {
    return request(`${API_ERECRUITMENT_PATH_V2_PUB}/get-detail`, {
      method: 'POST',
      data,
    });
  }
  return request(`${API_ERECRUITMENT_PATH_V2}/get-detail`, {
    method: 'POST',
    data,
  });
};

export const getPreCandidateDetailService = ({ eKyc = 0, preCandidateId }) => {
  const data = { eKyc, preCandidateId };
  return POST_REQUEST(structurePaths.detail.getDetail, data);
};

export const getEappProcessHistoryService = ({ preCandidateId }) => {
  const data = { preCandidateId };
  return POST_REQUEST(structurePaths.detail.getProcessHistories, data);
};

export const getDocBufferedDataService = ({ docId, docName }) => {
  const data = { docId, docName };
  return POST_REQUEST(structurePaths.common.getDocBufferedData, data);
};

export const updateByAmService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/update-by-am/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const recruiterCancelEAppService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/recruiter-cancel-eapp`, {
    method: 'POST',
    data,
  });
};

export const candidateDownloadService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/download?pCanId=${data}`, {
    method: 'GET',
  });
};

export const getAscoreService = (data) => {
  return request(`${API_ERECRUITMENT_PATH}/get-ascore?pCanId=${data}`, {
    method: 'GET',
  });
};

export const updateByAdService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/update-by-ad/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const updateByAosService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/update-by-aos/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const ERE_EKYC_INIT = `${API_ERECRUITMENT_PATH_V2_PUB}/ekyc/init-session`;
export const ERE_EKYC_OCR = `${API_ERECRUITMENT_PATH_V2_PUB}/ekyc/ocr`;
export const ERE_EKYC_LIVENESS = `${API_ERECRUITMENT_PATH_V2_PUB}/ekyc/liveness`;

export const verifyStatusEKyc = ({ id }) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/ekyc/status/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const checkLimits = ({ id, actions, hasError }) => {
  const body = {
    actions,
    hasError,
  };

  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/ekyc/limits/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
  });
};

export const resetEKycSession = ({ id }) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/ekyc/tracking/reset/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const acceptConsent = ({ id }) => {
  const body = {
    preCandidateId: id,
  };

  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/ekyc/accept-consent`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
  });
};

export const fetchHolidays = (year, month, pageNumber, pageSize) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/holidays/search`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: { year, month, pageNumber, pageSize },
  });
};

export const addHoliday = (holiday) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/holidays`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: holiday,
  });
};

export const removeHoliday = (holidayId) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/holidays/remove`, {
    method: 'GET',
    params: {
      holidayId,
    },
  });
};

// NOUS or FTA

export const nousRegisterByRecruiterService = (data) => {
  if (data?.isRecruitReSubmit) {
    return request(`${API_ERECRUITMENT_PATH_V2}/nous/resubmit-by-recruiter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  }
  return request(`${API_ERECRUITMENT_PATH_V2}/nous/register-by-recruiter`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const nousUpdateEmailByRecruiterService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/nous/update-email-by-recruiter`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const nousSaveByRecruiterService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/nous/save-temporary-by-recruiter`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const nousRecruiterCancelEAppService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/nous/recruiter-cancel-eapp`, {
    method: 'POST',
    data,
  });
};

export const nousCandidateCancelEAppService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/nous/candidate-cancel-eapp`, {
    method: 'POST',
    data,
  });
};

export const nousUpdateByPreCandidateService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/nous/update-by-pre-candidate`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const nousGetPreCandidateDetailService = ({
  eKyc = 0,
  preCandidateId,
  isCandidate = false,
}) => {
  const data = { eKyc, preCandidateId };
  if (isCandidate) {
    return POST_REQUEST(
      `${API_ERECRUITMENT_PATH_V2_PUB}/nous/get-detail`,
      data,
    );
  }
  return POST_REQUEST(structurePaths.nousDetail.getDetail, data);
};

export const ftaCheckStepCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/check-step-candidate`, {
    method: 'POST',
    data,
  });
};

export const ftaGenerateOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/generate-otp`, {
    method: 'POST',
    data,
  });
};

export const ftaReloadOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/reload-otp`, {
    method: 'POST',
    data,
  });
};

export const ftaVerifyOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/verify-otp`, {
    method: 'POST',
    data,
  });
};

export const nousUpdateByAmService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/nous/update-by-am/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const nousGetAscoreService = (data) => {
  return request(`${API_ERECRUITMENT_PATH}/get-ascore?pCanId=${data}`, {
    method: 'GET',
  });
};

export const nousUpdateByAdService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/update-by-ad/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const nousUpdateByAosService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/update-by-aos/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

// FLAIR

export const flairValidateCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/flair/candidates/validation`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const flairSaveByRecruiterService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/flair/save-temporary-by-recruiter`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const flairGetPreCandidateDetailService = ({
  eKyc = 0,
  preCandidateId,
}) => {
  const data = { eKyc, preCandidateId };
  return POST_REQUEST(structurePaths.flairDetail.getDetail, data);
};

export const flairRecruiterCancelEAppService = ({
  eKyc = 0,
  preCandidateId,
}) => {
  const data = { eKyc, preCandidateId };
  return request(`${API_ERECRUITMENT_PATH_V2}/flair/recruiter-cancel-eapp`, {
    method: 'POST',
    data,
  });
};

export const getCandidateReferrerInformationService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/flair/candidates/information`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const flairSearchPreCandidateERecruitment = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/flair/search-pre-candidate`, {
    method: 'POST',
    data,
  });

export const flairGetListStatus = () =>
  request(`${API_ERECRUITMENT_PATH_V2}/flair/status`, {
    method: 'GET',
  });

export const flairRegisterByRecruiterService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/flair/register-by-recruiter`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const flairCheckStepCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/flair/steps`, {
    method: 'POST',
    data,
  });
};

export const flairGenerateOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/flair/generate-otp`, {
    method: 'POST',
    data,
  });
};

export const flairVerifyOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/flair/verify-otp`, {
    method: 'POST',
    data,
  });
};

export const flairReloadOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/flair/reload-otp`, {
    method: 'POST',
    data,
  });
};

export const flairGetPublicEreDetailService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/flair/get-detail`, {
    method: 'POST',
    data,
  });
};

export const flairGetTrainingClassService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/flair/get-training-class`, {
    method: 'POST',
    data,
  });
};

export const flairSaveByCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/flair/save-by-candidate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const flairPublicValidateCandidateService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/flair/candidates/validation`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const flairUpdateByPreCandidateService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/flair/update-by-pre-candidate`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const flairCancelByCandidateService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/flair/candidate-cancel-eapp`,
    {
      method: 'POST',
      data,
    },
  );
};

export const flairResubmitByRecruiterService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/flair/resubmit-by-recruiter`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const flairUpdateByAdService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/flair/update-by-ad/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const flairPickUpByAosService = ({ id }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/flair/admin-pickup/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const flairSearchSuggestion = ({ suggestionName, type }) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/flair/get-suggestion?suggestionName=${suggestionName}&type=${type}`,
    {
      method: 'GET',
    },
  );
};

export const flairSaveTemporaryByAosService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/flair/save-by-aos/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const flairUpdateByAosService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/flair/update-by-aos/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const flairGetReturnProcessHistoryService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/flair/get-admin-return-history`,
    {
      method: 'POST',
      data,
    },
  );
};

// DELASOL
export const getAgentInfo = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/agents/info`, {
    method: 'POST',
    data,
  });
};

export const delasolSaveByRecruiterService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/delasol/save-temporary-by-recruiter`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const delasolRegisterByRecruiterService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/delasol/register-by-recruiter`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

// Save by Candidate Agency and Nous
export const agencySaveByCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/save-by-candidate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const delasolGetTrainingClassService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/delasol/get-training-class`, {
    method: 'POST',
    data,
  });
};

export const delasolRecruiterCancelEAppService = ({
  eKyc = 0,
  preCandidateId,
}) => {
  const data = { eKyc, preCandidateId };
  return request(`${API_ERECRUITMENT_PATH_V2}/delasol/recruiter-cancel-eapp`, {
    method: 'POST',
    data,
  });
};

export const delasolSearchPreCandidateERecruitment = (data) =>
  request(`${API_ERECRUITMENT_PATH_V2}/delasol/search-pre-candidate`, {
    method: 'POST',
    data,
  });

export const delasolGetListStatus = () =>
  request(`${API_ERECRUITMENT_PATH_V2}/delasol/status`, {
    method: 'GET',
  });

export const delasolGetPreCandidateDetailService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/delasol/get-detail`, {
    method: 'POST',
    data,
  });
};

export const delasolValidateCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/delasol/candidates/validation`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const delasolValidatePublicCandidateService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/delasol/candidates/validation`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const delasolUpdateEmailByRecruiterService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/delasol/update-email-by-recruiter`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const delasolCloneService = (data) => {
  // return POST_REQUEST(`${API_ERECRUITMENT_PATH_V2}/delasol/clone-eapp`, data);

  return request(`${API_ERECRUITMENT_PATH_V2}/delasol/clone-eapp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const nousSaveByCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/nous/save-by-candidate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const verifyS3ObjectService = ({ pCanId, url, key }) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/verify-s3-object`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: { pCanId, url, key },
  });
};

export const getTrainingClassForAD = ({ pCanId, hasWorkedAtSLV }) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/get-list-training-class-ad?pCanId=${pCanId}&hasWorkedAtSLV=${hasWorkedAtSLV}`,
    {
      method: 'GET',
    },
  );
};

// export const checkIdNumberInAgis = ({ pCanId, hasWorkedAtSLV }) => {
//   return request(
//     `${API_ERECRUITMENT_PATH}/check-id-number-in-agis?pCanId=${pCanId}&hasWorkedAtSLV=${hasWorkedAtSLV}`,
//     {
//       method: 'GET',
//     },
//   );
// };

export const checkIdNumberInAgisService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/check-id-number-in-agis`, {
    method: 'POST',
    data,
  });
};

export const checkAdSubmitWarningService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/check-ad-submit-warning`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const delasolGetPublicEreDetailService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/delasol/get-detail`, {
    method: 'POST',
    data,
  });
};

export const delasolSaveByCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/delasol/save-by-candidate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const delasolCheckStepCandidateService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/delasol/steps`, {
    method: 'POST',
    data,
  });
};

export const delasolGenerateOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/delasol/generate-otp`, {
    method: 'POST',
    data,
  });
};

export const delasolVerifyOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/delasol/verify-otp`, {
    method: 'POST',
    data,
  });
};

export const delasolReloadOTPService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2_PUB}/delasol/reload-otp`, {
    method: 'POST',
    data,
  });
};

export const delasolCancelByCandidateService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/delasol/candidate-cancel-eapp`,
    {
      method: 'POST',
      data,
    },
  );
};

export const delasolSearchSuggestion = ({ suggestionName, type }) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/delasol/get-suggestion?suggestionName=${suggestionName}&type=${type}`,
    {
      method: 'GET',
    },
  );
};

export const delasolUpdateByApproval1Service = ({ id, data }) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/delasol/update-by-approval1/${id}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const delasolResubmitByRecruiterService = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/delasol/resubmit-by-recruiter`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const delasolUpdateByPreCandidateService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/delasol/update-by-pre-candidate`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const getDelasolAgentService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/delasol/agents?agentCode=${data.agentCode}&type=${data.type}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};

export const getDelasolAgentForCandidateService = (data) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/delasol/agents?agentCode=${data.agentCode}&type=${data.type}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};

export const delasolUpdateByApproval2Service = ({ id, data }) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2}/delasol/update-by-approval2/${id}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
  );
};

export const delasolSaveTemporaryByAosService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/delasol/save-by-aos/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const delasolUpdateByAosService = ({ id, data }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/delasol/update-by-aos/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const getEAppProcessHistoryV2 = (data) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/get-eapp-process-history`, {
    method: 'POST',
    data,
  });
};

export const getListAgentTitleService = ({ channel }) => {
  return request(
    `${API_ERECRUITMENT_PATH_V2_PUB}/get-list-agent-title?channel=${channel}`,
    {
      method: 'GET',
    },
  );
};

export const getAssessInterview = ({ pCanId }) => {
  return request(`${API_ERECRUITMENT_PATH_V2}/get-assess?pCanId=${pCanId}`, {
    method: 'GET',
  });
};

export const getWards2LevelService = (provinceCode) => {
  return request(
    `${API_ERECRUITMENT_PATH}/get-wards-2-level?provinceCode=${provinceCode}`,
    {
      method: 'GET',
    },
  );
};

export const getAvicadDetailFlairService = (data) => {
  return POST_REQUEST(
    `${API_ERECRUITMENT_PATH_V2}/flair/get-avicad-detail`,
    data,
  );
};
